import { createSelector } from '../reselect';
import {
  total,
  simpleChart,
  _mergeAndSumObject,
  getNewStatsService,
  safeDivide,
  simpleChart2,
} from '../generalUtils';
const PROPS_TO_SELECTORS = {};

const getNewStats = getNewStatsService('pixel');

const pixelUniqueVisitors = createSelector([getNewStats], (stats) => {
  return total(stats, 'uniqueVisitorsAcrossDateRange');
});

const pixelVisitors = createSelector([getNewStats], (stats) => {
  return total(stats, 'pixelVisitors');
});

const pixelNonBouncedVisitors = createSelector([getNewStats], (stats) => {
  return total(stats, 'pixelNonBouncedVisitors');
});

const pixelUniqueAtc = createSelector([getNewStats], (stats) => {
  return total(stats, 'pixelUniqueAtc');
});

const pixelUniqueSessionsAtc = createSelector([getNewStats], (stats) => {
  return total(stats, 'uniqueAtcAcrossDateRange');
});

const pixelPercentAtc = createSelector([pixelUniqueSessionsAtc, pixelVisitors], (atc, visitors) => {
  return safeDivide(atc, visitors) * 100;
});

const pixelPurchases = createSelector([getNewStats], (stats) => {
  return total(stats, 'pixelPurchases');
});

const pixelConversionRate = createSelector(
  [pixelPurchases, pixelVisitors],
  (purchases, visitors) => {
    return safeDivide(purchases, visitors) * 100;
  }
);

const pixelPurchasesChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelPurchases');
});

const pixelUniqueVisitorsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelUniqueVisitors');
});

const pixelVisitorsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelVisitors');
});

const pixelNonBouncedVisitorsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelNonBouncedVisitors');
});

const pixelUniqueAtcChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelUniqueAtc');
});

const pixelUniqueSessionsAtcChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelUniqueSessionsAtc');
});

const pixelPercentAtcChart = createSelector(
  [pixelUniqueSessionsAtcChart, pixelVisitorsChart],
  (atc, visitors) => {
    return simpleChart2(atc, visitors, { chart1yMultiplier: 100 });
  }
);

const pixelConversionRateChart = createSelector(
  [pixelPurchasesChart, pixelVisitorsChart],
  (purchases, visitors) => {
    return simpleChart2(purchases, visitors, { chart1yMultiplier: 100 });
  }
);

const pixelPageViews = createSelector([getNewStats], (stats) => {
  return total(stats, 'pixelPageViews');
});

const pixelPageViewsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelPageViews');
});

const pixelTimeOnSite = createSelector([getNewStats], (stats) => {
  return total(stats, 'pixelTimeOnSite');
});

const pixelTimeOnSiteChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelTimeOnSite');
});

const pixelBounces = createSelector([getNewStats], (stats) => {
  return total(stats, 'pixelBounces');
});

const pixelBouncesChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelBounces');
});

const pixelNewVisitors = createSelector([getNewStats], (stats) => {
  return total(stats, 'pixelNewVisitors');
});

const pixelNewVisitorsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'pixelNewVisitors');
});

const pixelAvgPagesPerSession = createSelector(
  [pixelVisitors, pixelPageViews],
  (visitors, pageViews) => {
    return safeDivide(pageViews, visitors);
  }
);

const pixelAvgPagesPerSessionChart = createSelector(
  [pixelPageViewsChart, pixelVisitorsChart],
  (pageViews, visitors) => {
    return simpleChart2(pageViews, visitors);
  }
);

const pixelAvgSessionDuration = createSelector(
  [pixelTimeOnSite, pixelNonBouncedVisitors],
  (timeOnSite, visitors) => {
    return safeDivide(timeOnSite, visitors);
  }
);

const pixelAvgSessionDurationChart = createSelector(
  [pixelTimeOnSiteChart, pixelNonBouncedVisitorsChart],
  (timeOnSite, visitors) => {
    return simpleChart2(timeOnSite, visitors);
  }
);

const pixelBounceRate = createSelector([pixelBounces, pixelVisitors], (bounces, visitors) => {
  return safeDivide(bounces, visitors) * 100;
});

const pixelBounceRateChart = createSelector(
  [pixelBouncesChart, pixelVisitorsChart],
  (bounces, visitors) => {
    return simpleChart2(bounces, visitors, { chart1yMultiplier: 100 });
  }
);

const pixelPercentNewVisitors = createSelector(
  [pixelNewVisitors, pixelUniqueVisitors],
  (newVisitors, visitors) => {
    return safeDivide(newVisitors, visitors) * 100;
  }
);

const pixelPercentNewVisitorsChart = createSelector(
  [pixelNewVisitorsChart, pixelUniqueVisitorsChart],
  (newVisitors, visitors) => {
    return simpleChart2(newVisitors, visitors, { chart1yMultiplier: 100 });
  }
);

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    pixelUniqueVisitors,
    pixelVisitors,
    pixelUniqueAtc,
    pixelPurchases,
    pixelConversionRate,
    pixelPurchasesChart,
    pixelUniqueVisitorsChart,
    pixelVisitorsChart,
    pixelUniqueAtcChart,
    pixelUniqueSessionsAtc,
    pixelUniqueSessionsAtcChart,
    pixelPercentAtc,
    pixelPercentAtcChart,
    pixelConversionRateChart,
    pixelPageViews,
    pixelPageViewsChart,
    pixelTimeOnSite,
    pixelTimeOnSiteChart,
    pixelBounces,
    pixelBouncesChart,
    pixelNewVisitors,
    pixelNewVisitorsChart,
    pixelAvgPagesPerSession,
    pixelAvgPagesPerSessionChart,
    pixelAvgSessionDuration,
    pixelAvgSessionDurationChart,
    pixelBounceRate,
    pixelBounceRateChart,
    pixelPercentNewVisitors,
    pixelPercentNewVisitorsChart,
  },
};
